import React, { useEffect, useRef, useState } from 'react'
import Footer from "../../Components/Footer";
import { useParams } from "react-router-dom";
import PagesHeader from '../../Components/PagesHeader';
import { ApiService } from "../../Components/Services/apiservices";
import Accordion from 'react-bootstrap/Accordion';
import LightGallery from 'lightgallery/react';
import 'lightgallery/css/lightgallery.css';
import 'lightgallery/css/lg-zoom.css';
import 'lightgallery/css/lg-thumbnail.css';
import lgThumbnail from 'lightgallery/plugins/thumbnail'
import lgZoom from 'lightgallery/plugins/zoom'
let apiServices = new ApiService();
function Gallery() {
  const didMountRef = useRef(true);
  const { slug } = useParams();
  const [pageData, setPageData] = useState({})
  const [gallaryImages, setGallaryImages] = useState([])
  const [headerImage, setHeaderImage] = useState("")
  const [faqData, setfaqData] = useState([])

  useEffect(() => {
    if (didMountRef.current) {
      const dataString = {
        "page_url": "gallery"
      }
      apiServices.pagePostRequest(dataString).then(res => {
        if (res.data.status === "success") {
          if (res.data.pageData != null) {
            setPageData(res.data.pageData)
            setHeaderImage(res.data.page_header_url)
            getfaqData(res.data.pageData?.page_id)

          }
        }
      })
      apiServices.gallerycategoryGetRequest().then(res => {
        if (res.data.status == "success") {
          const categories = res.data.category || [];

          const fetchPromises = categories.map(cat =>
            apiServices.categorywisegallaryPostRequest({ category_slug: cat.category_slug })
          );

          Promise.all(fetchPromises).then(responses => {
            let allImages = [];
            responses.forEach(response => {
              if (response.data && response.data.status === "success") {
                const galleryUrl = response.data.gallery_url;
                const images = response.data.galleryData || [];
                images.forEach(img => {
                  if (img.gallery_image) {
                    allImages.push({ url: galleryUrl + img.gallery_image });
                  }
                });
              }
            });

            setGallaryImages(allImages);
          });
        }
      })
    }

    didMountRef.current = false;
  }, []);

  const getfaqData = (page_id) => {
    apiServices.getFaqDataRequest(page_id).then(res => {
      if (res.data.status === "success") {
        setfaqData(res.data.faqdata)
      }
    }).catch(() => { })

  }
  return (
    <>
      <PagesHeader />
      <style>
        {`
          .gallery-banner-responsive {
              background-image: url('/assets/img/food/Gallery-Desktop-Banner.webp');
          }
          @media (max-width: 768px) {
              .gallery-banner-responsive {
                  background-image: url('/assets/img/food/Gallery-Mobile-Banner.webp');
              }
          }
      `}
      </style>

      <div id="cappa-main">
        <div className="banner-header section-padding bg-position-bottom valign bg-img bg-fixed gallery-banner-responsive" data-overlay-dark="3" style={{ backgroundSize: 'cover', backgroundPosition: '100%' }}>
          <div className="container">
            <div className="row">
              <div className="col-md-12 text-center caption mt-90">
                <h5></h5>
                <h1 dangerouslySetInnerHTML={{ __html: pageData?.metadata?.page_title || 'Gallery' }} />
              </div>
            </div>
          </div>
        </div>
        <section className="our-story-section text-center" style={{ paddingTop: '80px', paddingBottom: '20px', backgroundColor: '#0b0c0b' }}>
          <div className="container">
            <div className="story-text-container-full mb-5">
              <p className="story-description">
                {pageData?.metadata?.page_desc || 'Take a visual journey through the exquisite ambiance, rich culinary heritage, and vibrant atmosphere of Chokhi Dhani London.'}
              </p>
            </div>
          </div>
          <style>{`
                .gallery-padded-container {
                    padding: 0 15px;
                }
                @media (min-width: 768px) {
                    .gallery-padded-container {
                        padding: 0 120px;
                    }
                }
            `}</style>
          <div className="container-fluid gallery-padded-container mb-0" style={{ overflowX: 'hidden' }}>
            <LightGallery
              speed={500}
              plugins={[lgThumbnail, lgZoom]}
              elementClassNames="row g-2"
            >
              {gallaryImages.map((value, index) => {
                return (
                  <a
                    href={value.url}
                    key={index}
                    className="col-12 col-md-4 col-lg-3"
                    style={{ display: 'block', textDecoration: 'none' }}
                  >
                    <div className="gallery-grid-item" style={{ height: 'auto', overflow: 'hidden', borderRadius: '4px' }}>
                      <img
                        src={value.url}
                        alt={`Gallery Image ${index + 1}`}
                        style={{ width: '100%', height: 'auto', display: 'block', transition: 'transform 0.5s ease' }}
                        onMouseOver={e => e.currentTarget.style.transform = 'scale(1.05)'}
                        onMouseOut={e => e.currentTarget.style.transform = 'scale(1)'}
                      />
                    </div>
                  </a>
                );
              })}
            </LightGallery>
          </div>
        </section>
        {faqData && faqData?.length > 0 && (
          <section className="rooms1 section-padding bg-blck-light" data-scroll-index="2">
            <div className="container">

              <div className="row">
                <h2 className="text-center mb-5">Frequently Asked Questions</h2>
                <Accordion defaultActiveKey="0" flush>
                  {faqData?.map((item, index) => (
                    <Accordion.Item eventKey={`${index}`} key={index}>
                      <Accordion.Header>{item?.faq_title}</Accordion.Header>
                      <Accordion.Body>
                        <div dangerouslySetInnerHTML={{ __html: item?.faq_description }} style={{ color: 'black' }}></div>
                      </Accordion.Body>
                    </Accordion.Item>
                  ))}
                </Accordion>
              </div>
            </div>
          </section>
        )}
      </div>

      <Footer />
    </>
  )
}

export default Gallery